<template>
  <v-app-bar height="71" :elevation="0" color="#DD0E1A">
    <!-- <v-icon class="pl-6" color="#FFFFFF" size="25" @click="openSideBar()">mdi-view-headline</v-icon> -->
    &nbsp;
    <v-icon @click="setMenuOpen()" color="#FFFFFF" size="large" class="ml-6 mr-2">
      mdi mdi-menu
    </v-icon>
    <span style="color: #ffffff" class="text-h6"> <b> Synergy </b></span>
    <template v-slot:append>
      <v-btn variant="text" id="menu-activator"
        ><v-icon color="#FFFFFF" size="25">mdi-account-circle-outline</v-icon>
        <v-tooltip activator="parent" location="bottom">Profile</v-tooltip>
      </v-btn>
      <MenuOptions
        @menu-selected="logOut($event)"
        :options="userProfileOptions"
        activator="#menu-activator"
      />
    </template>
    <v-card class="menu-bar" :class="{ 'menu-open': menuOpen }">
      <ul class="d-flex flex-column">
        <li class="menus pa-2" @click="setMenuOpen('/')">
          Home
        </li>
        <li class="menus pa-2" @click="setMenuOpen('action')">Action</li>
      </ul>
    </v-card>
  </v-app-bar>
</template>

<script>
import MenuOptions from "@/menu/MenuOptions.vue";
export default {
  components: {
    MenuOptions,
  },

  data() {
    return {
      userProfileOptions: [{ title: "User Profiles", action: "/user" }, { title: "Logout" }],
      menuOpen: false,
    };
  },
  methods: {
    logOut($event) {
     // let $timerData = JSON.parse(localStorage.getItem("timer"));
      if ($event.title == "Logout") {
        this.$router.push("/logout");
        // if ($timerData) {
        //   this.$store.dispatch("setSnackbar", {
        //     color: "error",
        //     text: `Stop the running ${$timerData.type} before LOGOUT`,
        //   });
        // } else {
        //   this.$router.push("/logout");
        // }
      }
    },
    setMenuOpen(type) {
      if(type){
        this.$router.push(type)
      }
       
      this.menuOpen = !this.menuOpen;
    },
  },
};
</script>

<style scoped>
.iconDiv {
  position: absolute;
  right: 500px;
}

.img {
  width: 25px;
  height: 25px;
}

>>> .v-menu > .v-overlay__content > .v-card,
.v-menu > .v-overlay__content > .v-sheet,
.v-menu > .v-overlay__content > .v-list {
  background: rgb(var(--v-theme-surface));
  border-radius: inherit;
  overflow: auto;
  height: 100%;
  width: 150%;
  box-shadow: 0px 5px 5px -3px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)),
    0px 8px 10px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)),
    0px 3px 14px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.12));
  width: 50% !important;
  margin-left: 15%;
  margin-top: 1%;
}

>>> .mdi-check::before {
  color: #03b603;
  content: "\F012C";
}

/* .avatar:hover {
    cursor: pointer;
    width: 3rem;
    height: 3rem;
  } */

>>> .work-space-menu {
  cursor: pointer;
}

>>> .menus {
  cursor: pointer;
}

>>> .menus:hover {
  background-color: rgb(234, 238, 243);
}

.view-all {
  position: relative;
  color: blue;
  padding: 37%;
  cursor: pointer;
}

>>> .v-menu > .v-overlay__content > .v-card,
>>> .v-menu > .v-overlay__content > .v-sheet,
>>> .v-menu > .v-overlay__content > .v-list {
  background: rgb(var(--v-theme-surface));
  border-radius: inherit;
  overflow: auto;
  height: 100%;
  width: 150%;
  box-shadow: 0px 5px 5px -3px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)),
    0px 8px 10px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)),
    0px 3px 14px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.12));
}

>>> .v-list-item--one-line .v-list-item-subtitle {
  /* -webkit-line-clamp: 1; */
  font-size: 60%;
  font-weight: bold;
  background-color: rgb(170, 163, 163);
  /* outline: #4CAF50 solid 2px; */
  margin: 3px;
  width: 20%;
  border-radius: 3px;
  padding: 1%;
  text-align: start;
}

.subtitle {
  background-color: rgb(207, 202, 202);
  margin: 3px;
  /* color: ; */
  font-size: 11px;
  font-weight: 600;
  text-align: start;
  color: grey;
  border-radius: 5px;
  padding: 5px;
}
.menu-bar {
  transition: all 0.6s;
  position: fixed;
  top: 72px;
  left: -50%;
  height: 100vh;
  width: 18%;
  background-color: #ffff;
  box-shadow: 0 10px 5px #000;
}
.menu-open {
  left: 0;
}
.menu-bar ul {
  margin-left: 10px;
  margin-top: 10px;
}
.menu-bar li {
  list-style: none;
  
}
.menu-bar a {
  font-family: Quicksand !important;
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
  color: #000000;
}
.btn-color {
  filter: invert(84%) sepia(0%) saturate(6234%) hue-rotate(246deg) brightness(87%) contrast(156%);
}

.plus-menu .v-list-item {
  width: 250px;
}

/* .v-list-item .v-list-item--link v-theme--myCustomLightTheme v-list-item--density-default v-list-item--one-line v-list-item--variant-text */
</style>
